import Icons from 'assets/icons';

interface AuthorProps {
  avatar?: string;
  name?: string;
  position?: string;
}

const Author = ({ avatar, name, position }: AuthorProps): React.JSX.Element => (
  <div className="flex items-center bg-navy-50 py-2.5 px-4 rounded-md">
    {avatar ? (
      <img
        src={avatar}
        alt={name}
        className="flex h-10 w-10 justify-center rounded-[50%] mr-1"
      />
    ) : (
      <Icons.Profile
        className="w-10 h-10 text-navy-200 mr-1"
        aria-hidden="true"
      />
    )}
    <div>
      <div className="text-neutral-950 font-semibold">{name}</div>
      <div className="text-gray-700 text-sm">{position}</div>
    </div>
  </div>
);

export default Author;
